const COOKIE_NAME = 'cookieConsent';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

export function loadShoreWidget() {
  const container = document.querySelector(".js-shore-booking-button");
  if (!container) return;

  const buttonLabel = container.dataset.buttonLabel;

  // Always (re)assign settings before loading script
  window.shoreBookingSettings = {
    themeColor: '#ff3f50',
    textColor: '#ffffff',
    text: buttonLabel,
    company: 'aimcenter-irschenberg-gmbh',
    locale: 'de',
    position: 'right',
    selectLocation: false,
  };

  // If script is already loaded, don’t inject again
  const existing = document.querySelector('script[data-shore-widget-script="true"]');
  if (!existing) {
    const script = document.createElement("script");
    script.src = "https://connect.shore.com/widget/booking.js";
    script.async = true;
    script.dataset.shoreWidgetScript = "true";

    script.onload = () => {
      console.log("Shore booking widget loaded!");

      // If Shore internally only hooks into window.onload, we can simulate a load event:
      try {
        window.dispatchEvent(new Event('load'));
      } catch (e) {
        // older browsers fallback
        const event = document.createEvent('Event');
        event.initEvent('load', false, false);
        window.dispatchEvent(event);
      }
    };

    document.head.appendChild(script);
  } else {
    // Script is already in the page. Some widgets need re-evaluation of settings.
    // Shore usually reacts to shoreBookingSettings; if needed, we force a load event:
    try {
      window.dispatchEvent(new Event('load'));
    } catch (e) {
      const event = document.createEvent('Event');
      event.initEvent('load', false, false);
      window.dispatchEvent(event);
    }
  }
}

export function loadShoreIframes() {
  document.querySelectorAll('[data-shore-iframe-src]').forEach((iframe) => {
    const placeholder = iframe.closest('.shore-embed')?.querySelector('[data-shore-placeholder]');
    const targetSrc = iframe.dataset.shoreIframeSrc;

    if (targetSrc) {
      iframe.src = targetSrc;
    }

    iframe.style.display = '';

    if (placeholder) {
      placeholder.style.display = 'none';
    }
  });
}

function showPlaceholderHideIframe() {
  document.querySelectorAll('[data-shore-iframe-src]').forEach((iframe) => {
    const placeholder = iframe.closest('.shore-embed')?.querySelector('[data-shore-placeholder]');

    iframe.removeAttribute('src');
    iframe.style.display = 'none';

    if (placeholder) {
      placeholder.style.display = '';
    }
  });
}

function initShoreOnLoad() {
  const consentManagerEnabled =
    (typeof window.__consentManagerEnabled === 'undefined')
      ? true
      : !!window.__consentManagerEnabled; // force value to strict boolean

  if (!consentManagerEnabled) {
    // Consent manager off → always load
    loadShoreWidget();
    loadShoreIframes();
    return;
  }

  const cookie = getCookie(COOKIE_NAME);

  if (cookie === 'true') {
    loadShoreWidget();
    loadShoreIframes();
  } else {
    // cookie === null or 'false' → only placeholder
    showPlaceholderHideIframe();
  }
}

// In a typical WP + webpack setup main.js is loaded at the bottom → DOM is ready.
initShoreOnLoad();
